import { DataStorage } from './store/storage';

import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticatedHttpService } from '@planwork/services/authenticated-http.service';
import { PlanworkConfigService } from '@planwork/services/config.service';
import { CommonService } from './main/core/common/common.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
 
  title = 'planwork';
  public counter: number;
  public timer: any;
  // onWindowLoad(event: any) {
  //  this.CommonService.loadUserPermissions()
  // .catch(error => {
  //   console.error('Error loading user permissions:', error);
  // });
  // }
  constructor(
    private store: DataStorage,
    public router: Router,
    public CommonService: CommonService,
    private plService: PlanworkConfigService
  ) {
    let user = JSON.parse(localStorage.getItem('userid'));
    if (user) {
      this.store.userRoleList();
      this.store.masterRoleList();
    }
  }
  ngOnInit() {
    this.plService.setHrsCount.subscribe(res => {
      this.counter = res;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.counter--;
        if (this.counter === 0) {
          clearInterval(this.timer);
          this.plService.logout();
        }
      }, 1000);
    })
  }
}
